<template>
  <div>
    <BaseTitle :title="$t('menu.profile')" />
    <v-row>
      <v-col cols="12" md="auto" style="width: 330px">
        <v-card>
          <div class="pa-8 mb-4">
            <div v-if="showPhoto">
              <div class="app-section-title">{{ $t('content.user_upload_title') }}</div>
              <form-group :name="$t('form.image')" :validator="$v.form.image" no-gutter>
                <template slot-scope="{ attrs }">
                  <image-box
                    v-model="form.image"
                    v-bind="attrs"
                    :with-upload="!form.primarySchoolAdmin"
                    :upload-btn-text="$t('upload')"
                    :image-preview="imageUrl"
                    class="mt-4"
                  />
                </template>
              </form-group>
            </div>
            <v-btn color="primary" block class="btn-primary-custom" v-if="!showPhoto" :disabled="form.primarySchoolAdmin" @click="togglePhoto">
              {{ $t('content.add_photo') }}
            </v-btn>
          </div>
        </v-card>
        <v-card>
          <div class="px-8 py-3" style="background-color:#00BF63; color:#FFFFFF;">
            Role User
          </div>
          <div class="px-8 py-4" style="color:#6D6D6D;">
            <b>
              <div class="user-info-secondary">{{ roleName }}</div>
            </b>
          </div>
        </v-card>
        <br />
      </v-col>
      <v-col>
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <div class="app-section-title">{{ $t('content.personal_information') }}</div>
              <form-group :name="$t('form.first_name')" :validator="$v.form.firstName">
                <template slot-scope="{ attrs }">
                  <v-text-field v-model="form.firstName" v-bind="attrs" @input="$v.form.firstName.$touch()" @blur="$v.form.firstName.$touch()">
                    <template #label>
                      {{ $t('form.first_name') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group :name="$t('form.last_name')" :validator="$v.form.lastName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.lastName"
                    :label="$t('form.last_name')"
                    v-bind="attrs"
                    @input="$v.form.lastName.$touch()"
                    @blur="$v.form.lastName.$touch()"
                  />
                </template>
              </form-group>
              <form-group v-if="isStudent" :name="$t('form.student_id')" :validator="$v.form.identityNumber">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.identityNumber"
                    v-bind="attrs"
                    :label="$t('form.student_id')"
                    @input="$v.form.identityNumber.$touch()"
                    @blur="$v.form.identityNumber.$touch()"
                  />
                </template>
              </form-group>
              <form-group :name="$t('form.gender')" :validator="$v.form.gender">
                <template slot-scope="{ attrs }">
                  <v-select :items="gender" v-bind="attrs" v-model="form.gender">
                    <template #item="{item}">
                      {{ $t(item.text) }}
                    </template>
                    <template #selection="{item}">
                      {{ $t(item.text) }}
                    </template>
                    <template #label>
                      {{ $t('form.gender') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-select>
                </template>
              </form-group>
              <form-group :name="$t('form.place_of_birth')" :validator="$v.form.placeOfBirth">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.placeOfBirth"
                    v-bind="attrs"
                    :label="$t('form.place_of_birth')"
                    @input="$v.form.placeOfBirth.$touch()"
                    @blur="$v.form.placeOfBirth.$touch()"
                  >
                    <template #label>
                      {{ $t('form.place_of_birth') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group v-slot="{ attrs, on }" :name="$t('form.date_of_birth')" :validator="$v.form.dateOfBirth">
                <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                    <v-text-field
                      v-model="form.dateOfBirth"
                      readonly
                      v-bind="{ ...attrs, ...menuAttrs }"
                      v-on="{ ...on, ...menuOn }"
                      @blur="$v.form.dateOfBirth.$touch()"
                    >
                      <template #label>
                        {{ $t('form.date_of_birth') }}
                        <span class="error--text">*</span>
                      </template>
                      <template #append> <svg-icon icon="calendar" class="primary--text mr-3" /> </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="form.dateOfBirth" :active-picker.sync="activePicker" :max="datemaxcurrent" :locale="$i18n.locale">
                    <template #label>
                      {{ $t('form.date_of_birth') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-date-picker>
                </v-menu>
              </form-group>
              <form-group :name="$t('form.email')" :validator="$v.form.email">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.email"
                    v-bind="attrs"
                    :disabled="form.primarySchoolAdmin == true || form.primaryMasterAdmin == true"
                    @input="$v.form.email.$touch()"
                    @blur="$v.form.email.$touch()"
                  >
                    <template #label>
                      {{ $t('form.email') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group :name="$t('form.phone_number')" :validator="$v.form.phoneNumber">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.phoneNumber"
                    v-bind="attrs"
                    v-phone
                    :label="$t('form.phone_number')"
                    @input="$v.form.phoneNumber.$touch()"
                    @blur="$v.form.phoneNumber.$touch()"
                    @keypress="onlyNumbers($event)"
                  >
                    <template #label>
                      {{ $t('form.phone_number') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <div class="app-section-title mb-3">{{ $t('content.account_information') }}</div>
              <v-btn color="primary" class="btn-primary-custom mb-10 pa-5" @click="showChangePass">{{ $t('change_password') }}</v-btn>
              <v-btn color="primary" class="btn-primary-custom mb-10 pa-5 ml-3" @click="deleteAccount">{{ $t('delete_user') }}</v-btn>
              <form-group :name="$t('form.address')" :validator="$v.form.address">
                <template slot-scope="{ attrs }">
                  <v-textarea v-model="form.address" v-bind="attrs" @input="$v.form.address.$touch()" @blur="$v.form.address.$touch()">
                    <template #label>
                      {{ $t('form.address') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-textarea>
                </template>
              </form-group>
              <form-group :name="$t('form.province')" :validator="$v.form.provinceId">
                <template slot-scope="{ attrs }">
                  <v-select :items="provinces" item-value="provinceId" item-text="name" v-bind="attrs" v-model="form.provinceId" @change="getCities">
                    <template #label>
                      {{ $t('province') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-select>
                </template>
              </form-group>
              <form-group :name="$t('form.city')" :validator="$v.form.cityId">
                <template slot-scope="{ attrs }">
                  <v-select :items="cities" item-value="cityId" item-text="name" v-bind="attrs" v-model="form.cityId">
                    <template #label>
                      {{ $t('city') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-select>
                </template>
              </form-group>
              <form-group :name="$t('form.postal_code')" :validator="$v.form.postalCode">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    minlength="5"
                    maxlength="5"
                    v-model.number="form.postalCode"
                    v-bind="attrs"
                    v-number
                    :label="$t('form.postal_code')"
                    @input="$v.form.postalCode.$touch()"
                    @blur="$v.form.postalCode.$touch()"
                  />
                </template>
              </form-group>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backToList">{{ $t('back') }}</v-btn>
            <v-btn color="primary" :loading="loading" class="btn-primary-custom" type="submit">{{ $t('save') }}</v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogChangePassword">
      <change-password @hide="dialogChangePassword = false" />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, email, numeric, maxLength } from 'vuelidate/lib/validators';
import BaseTitle from '@/components/base/Title';
import phoneNumber from '@/validators/phoneNumber';
import ImageBox from '@/components/ImageBox';
import { fileSize, alphaSpace } from '@/validators';
import ChangePassword from '@/components/ChangePassword';

export default {
  name: 'EditProfile',
  components: {
    BaseTitle,
    ImageBox,
    ChangePassword
  },
  computed: {
    ...mapGetters({
      status: 'Reference/itemStatus',
      provinces: 'Reference/itemProvinces',
      gender: 'Reference/itemGender',
      currentId: 'Auth/currentId',
      user: 'Auth/user'
    }),
    cities: {
      get() {
        return this.$store.getters['Reference/itemCities']();
      }
    },
    roleName() {
      const roles = {
        1: 'roles.master_administrator',
        2: 'roles.school_administrator',
        3: 'roles.parents',
        4: 'roles.teacher',
        5: 'roles.student',
        6: 'roles.school_advisor'
      };
      return this.$t(roles?.[this.form.roleId]);
    },
    datemaxcurrent() {
      const d = new Date();
      d.setFullYear(d.getFullYear() - (this.isStudent ? 5 : 17));
      return d.toISOString().split('T')[0];
    }
  },
  validations() {
    const roleId = parseInt(this.form.roleId);
    let maxLengthValue = 50;

    switch (roleId) {
      case 4: // Teacher
        maxLengthValue = 15;
        break;
      case 5: // Student
        maxLengthValue = 30;
        break;
    }

    return {
      form: {
        image: { fileSize: fileSize(1) },
        firstName: {
          required,
          alphaSpace,
          maxLength: maxLength(maxLengthValue)
        },
        lastName: { alphaSpace, maxLength: maxLength(maxLengthValue) },
        phoneNumber: { phone: phoneNumber, maxLength: maxLength(15) },
        email: { required, email },
        gender: { required },
        address: { required, maxAddressLength: maxLength(255) },
        placeOfBirth: { required },
        dateOfBirth: {
          required,
          date: function(value) {
            return this.datemaxcurrent ? value <= this.datemaxcurrent : true;
          }
        },
        provinceId: { required },
        cityId: { required },
        postalCode: { numeric, maxLength: maxLength(5) }
      }
    };
  },
  data: () => ({
    form: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      gender: '',
      address: '',
      placeOfBirth: '',
      provinceId: null,
      dateOfBirth: '',
      cityId: '',
      identityNumber: '',
      postalCode: '',
      roleId: '',
      schoolId: '',
      image: null,
      student: '',
      primarySchoolAdmin: '',
      primaryMasterAdmin: '',
      classroomStatusDetail: ''
    },
    isStudent: false,
    validationName: 'dynamic',
    showPhoto: false,
    dialog: false,
    dialogDeactivate: false,
    dialogChangePassword: false,
    imageUrl: null,
    menu: false,
    loading: false,
    previousRoute: null,
    activePicker: null
  }),
  methods: {
    getData() {
      this.$store.dispatch('User/fetchProfile', this.currentId).then(res => {
        // Object.keys(this.form).forEach(form => (this.form[form] = res[form]));
        Object.keys(this.form).forEach(form => {
          this.form[form] = res[form];
        });
        if (res.roleId === 5) {
          this.isStudent = true;
        }
        this.form.image = null;
        if (res.imageUrl) {
          this.imageUrl = res.imageUrl;
          this.showPhoto = true;
        }
        this.getCities();
        this.hasLoad = true;
      });
    },
    getProvinces() {
      this.$store.dispatch('Reference/fetchProvinces');
    },
    getCities() {
      if (this.hasLoad) {
        this.form.cityId = null;
      }
      this.$store.dispatch('Reference/fetchCities', this.form.provinceId);
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return false;

      this.loading = true;
      this.$store
        .dispatch('User/updateprofile', this.form)
        .then(() => this.$router.push({ name: 'UserProfileUpdate' }))
        .finally(() => (this.loading = false));
    },
    backToList() {
      const { roleId } = this.form;

      const routes = {
        1: 'ReportAdminIndex',
        2: 'MasterUserSchool',
        3: 'ChildList',
        4: 'TeacherClassIndex',
        5: 'StudentClassIndex',
        6: 'StudentIndex'
      };
      this.$router.push({ name: routes[roleId] });
    },
    showChangePass() {
      this.dialogChangePassword = true;
    },
    deleteAccount() {
      this.$router.push({ name: 'AuthLogin', query: { process: 'deleteAccount', email: this.user.email } });
    },
    togglePhoto() {
      this.showPhoto = !this.showPhoto;
    },
    onlyNumbers(e) {
      const char = String.fromCharCode(e.keyCode);
      if (!/\d/.test(char)) {
        e.preventDefault();
      }
    }
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    }
  },
  created() {
    this.$store.commit('Reference/RESET_CITIES');
    this.getProvinces();
    this.getData();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => (vm.previousRoute = from));
  }
};
</script>
